class Gallery {
  constructor(node) {
    this.node = node;
    const $items = $(node).children('.js-gallery-item');

    this.handleItemClick = this.handleItemClick.bind(this);
    this.data = [];

    $items.each((idx, $el) => {
      const src = $el.getAttribute('src');
      const title = $el.dataset.title;

      this.data.push({
        src,
        title
      });
    });

    $items.each((idx, $el) => {
      $($el).click(this.handleItemClick(idx));
    });

    // $('.js-gallery-wrap').slick({
    //   slidesToShow: 1,
    //   variableWidth: true,
    // });

    // console.log(this.data, this.data.split);

    this.gallery = $.magnificPopup.instance;

    // console.log(this.gallery);
  }

  handleItemClick(idx) {
    return event => {
      // console.log(idx, event);

      this.gallery.open({
        type: 'image',
        gallery: {
          enabled: true
        },
        items: this.data,
        index: idx,
        callbacks: {
          open: function() {
            $('body').css('overflow', 'hidden');
          },
          close: function() {
            $('body').css('overflow', 'auto');
          }
        }
      });

      /* Espera carregar o lightbox */
      setTimeout(() => {
        /* Swipe para a esquerda - Próximo */
        $('.mfp-container').swipe({
          swipeLeft: (event, direction, distance, duration, fingerCount) => {
            // console.log("swipe right");
            this.gallery.next();
          },

          /* Swipe para a direita - Anterior */
          swipeRight: (event, direction, distance, duration, fingerCount) => {
            // console.log("swipe left");
            this.gallery.prev();
          }
        });
      }, 500);
    };
  }
}

export default () => {
  const selectNodes = Array.from(document.querySelectorAll('.js-gallery'));

  if (!selectNodes.length) {
    return;
  }

  selectNodes.forEach(node => {
    window.gallery = new Gallery(node);
  });
};



// WEBPACK FOOTER //
// ./assets/scripts/components/gallery.js